module["exports"] = [
  "AC",
  "AL",
  "AP",
  "AM",
  "BA",
  "CE",
  "DF",
  "ES",
  "GO",
  "MA",
  "MT",
  "MS",
  "PA",
  "PB",
  "PR",
  "PE",
  "PI",
  "RJ",
  "RN",
  "RS",
  "RO",
  "RR",
  "SC",
  "SP"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pt_BR/address/state_abbr.js
// module id = 1576
// module chunks = 0